
  import React from "react"
  import Component from "C:/Users/damir/Documents/Projects/Iskraemeco/src/layouts/index.js"
  import data from "C:\\Users\\damir\\Documents\\Projects\\Iskraemeco\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js